/******************NOTAS******************/

// 1.- SEPARAR LAS VISTAS DE LOS CATALOGOS CON LOS DE LOS MODULOS.
// 2.- LOS NOMBRES DE LOS COMPONENTES SIEMPRE IRAN CON MAYUSCULAS.
//     EL PATH Y EL COMPONENT COMIENZAN CON MAYUSCULA CADA INICIO DE PALABRA.
//     EL NAME COMIENZA CON MINUSCULA.
// 3.- SI REQUIERE PROPS, ACTIVARLO CON UN TRUE.

/**************FIN DE NOTAS**************/

// -------------------------------------------------------------------------- IMPORTACIONES PRINCIPALES -----------------------------------------------------------
import Vue       from "vue";
import VueRouter from "vue-router";
import Store     from "../store/index";

// -------------------------------------------------------------------------- IMPORTACIONES GENERALES --------------------------------------------------------------
import Template          from "../views/template/Template.vue";
import Login             from "../views/security/Login.vue";
import RecuperarPassword from "../views/security/RecuperarPassword.vue";
import RecoveryAccount   from "../views/security/RestablecerPassword.vue";
import EncuestaEnlace from '../views/modulos/crm/encuestaResuelta/CorreoRespuesta.vue';
import EncuestaResueltaCoordinador from '../views/modulos/crm/encuestaResuelta/Form.vue';
import EncuestaConfirmacion from '../views/modulos/crm/encuestaResuelta/Confirmacion.vue';

// -------------------------------------------------------------------------- IMPORTACIONES HIJAS ------------------------------------------------------------------
import RouterImportInicio        from "./RutasInicio.js";
import RouterImportCrm           from "./RutasCrm.js";
import RouterImportEmpresa       from "./RutasEmpresa.js";
import RouterImportConfiguracion from "./RutasConfiguracion.js";
import RouterImportFinanzas from "./RutasFinanzas.js";
import RouterImportAlmacen from "./RutasAlmacen.js";


const ArrayRutas = RouterImportInicio.VarRutasInicio.concat(
    RouterImportEmpresa.VarRutasEmpresa,
    RouterImportCrm.VarRutasCrm,
    RouterImportConfiguracion.VarRutasConfiguracion,
    RouterImportFinanzas.VarRutasFinanzas,
    RouterImportAlmacen.VarRutasAlmacen
);

Vue.use(VueRouter);

const routes = [{
    path: "/",
    name: "login",
    component: Login,
}, {
    // ------------------------------------------------ RUTAS GENERALES ------------------------------------------------
    path: "/Inicio",
    name: "template",
    component: Template,
    props: true,
    meta: {
        requiresAuth: true,
    },
    children: ArrayRutas,
}, {
    path: '/RecuperarPassword',
    name: 'recuperarpassword',
    component: RecuperarPassword,
    props: true,
}, {
    path: '/recoveryaccount/:key/:id/:num',
    name: 'recoveryaccount',
    component: RecoveryAccount,
},  {
    path:'/responderencuesta/:key/:id/:rol/:num/:emp/:suc',
    name:'responderencuesta',
    component:EncuestaEnlace
},  {
    path: '/ResponderEncuesta',
    name: 'encuestaResueltaCoordinador',
    component: EncuestaResueltaCoordinador,
    props: true
},  {
    path: '/EncuestaConfirmacion',
    name: 'encuestaConfirmacion',
    component: EncuestaConfirmacion,
    props: true
},];

const router = new VueRouter({
    mode: 'history',  // Cambiamos la visualización del # en la url de la vista.
    routes,
});

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (Store.getters.isLoggedIn) {
            next();
            return;
        }
        next("/");
    } else {
        next();
    }
});

const originalPush       = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default router;
